/**
 * Rango de fechas de las exportaciones (ADS-0186).
 *
 * Exportar la base entera dejaba el servidor sin memoria, así que ADS exporta
 * con fecha desde y hasta, de un año como máximo. La API aplica la misma regla
 * (ExportDateRange): aquí se avisa antes de pedir el archivo.
 */
export const EXPORT_RANGE_MAX_YEARS = 1

const pad = (value) => String(value).padStart(2, '0')

/** Fecha local en formato yyyy-mm-dd, el de los <input type="date">. */
export const toInputDate = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

const addYears = (isoDate, years) => {
  const [year, month, day] = isoDate.split('-').map(Number)
  // Como Carbon::addYears: el 29/02 pasa al 01/03.
  return toInputDate(new Date(year + years, month - 1, day))
}

/** Los últimos doce meses, hasta hoy: el valor inicial de los filtros. */
export const defaultExportRange = (today = new Date()) => {
  const to = toInputDate(today)

  return { from: addYears(to, -EXPORT_RANGE_MAX_YEARS), to }
}

/**
 * Motivo por el que el rango no vale, o '' si se puede exportar:
 * `required` (falta alguna fecha), `order` (hasta antes que desde) o
 * `tooLong` (más de un año).
 */
export const exportRangeError = (from, to) => {
  if (!from || !to) return 'required'
  if (to < from) return 'order'
  if (to > addYears(from, EXPORT_RANGE_MAX_YEARS)) return 'tooLong'

  return ''
}
